import { Spot } from "Domain/Model/Spot/Spot";

export const UPDATE_SPOT_SUCCESS = 'UPDATE_SPOT_SUCCESS';

export const updateSpotSuccess = (payload: Record<string, Spot>) => ({
    type: UPDATE_SPOT_SUCCESS,
    payload,
});
